import { concatSeparator } from 'helpers'
import { getTypedState } from 'ducks/hooks'
import { Estimate, PaymentOption } from 'ducks/types'
import { NewRepairListType } from './types'

export const getNewRepairListStep = () => (): any => {
  const { newRepairList: { step } } = getTypedState()
  return step || 0
}

export const getNewRepairListValue = (type: string) => (): any => {
  const { newRepairList } = getTypedState()
  return newRepairList[type as keyof NewRepairListType] || null
}

export const getNewRepairListValues = () => (): NewRepairListType => {
  const { newRepairList } = getTypedState()
  return newRepairList
}

export const getNewRepairListAddress = (): string => {
  const { newRepairList } = getTypedState()
  const { city, line_1: street1, line_2: unit, state, line1, line2 } = newRepairList.address
  const cityState = concatSeparator(city ?? '', state ?? '', ', ')
  const streetUnit = concatSeparator(street1 || line1 as string, unit || line2 as string, ', ')
  const address = concatSeparator(streetUnit ?? '', cityState ?? '', ', ')
  return address || 'No address'
}

export const getNewRepairListFullAddress = (): string => {
  const { newRepairList } = getTypedState()
  const { city, line_1: street1, state, zipCode, line1, line2 } = newRepairList.address
  let address = concatSeparator(street1 || line1 as string, city ?? '', ', ')
  address = concatSeparator(address, state + ' ' + zipCode, ', ')
  address = concatSeparator(address, line2 || '', ', ')
  return concatSeparator(address, 'USA', ', ') || 'No address'
}

export const getNewRepairListData = () => (): Partial<Estimate> => {
  const { newRepairList } = getTypedState()
  return newRepairList.estimate
}

export const getNewRepairListPaymentOptions = () => (): PaymentOption[] | null => {
  const { newRepairList } = getTypedState()
  return newRepairList.paymentOptions
}

export const getNewRepairListPaymentOption = () => (): PaymentOption | null => {
  const { newRepairList } = getTypedState()
  return newRepairList.paymentOption
}

export const getNewRepairListExpediteOption = () => (): PaymentOption | null => {
  const { newRepairList } = getTypedState()
  const selected = newRepairList.paymentOption
  if (!selected) return null
  return newRepairList.paymentOptions?.find(option => option.date < selected.date) ?? null
}
